"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidation = exports.requiredMessage = void 0;
var requiredMessage = 'Please fill in this field';
exports.requiredMessage = requiredMessage;

var getValidation = function getValidation(config) {
  var _config$minLength = config.minLength,
      minLength = _config$minLength === void 0 ? 0 : _config$minLength,
      _config$maxLength = config.maxLength,
      maxLength = _config$maxLength === void 0 ? 999 : _config$maxLength,
      _config$optional = config.optional,
      optional = _config$optional === void 0 ? false : _config$optional,
      _config$chars = config.chars,
      chars = _config$chars === void 0 ? '*' : _config$chars;
  var min = new RegExp("^.{".concat(minLength, ",}$"));
  var max = new RegExp("^.{0,".concat(maxLength, "}$"));
  var characters = new RegExp("^".concat(chars === '*' ? '.' : '[' + chars + ']', "*$"));
  return function (value) {
    if (!value && !optional) {
      return requiredMessage;
    }

    if (!characters.test(value)) {
      return "Only characters between ".concat(chars, " allowed");
    }

    if (!min.test(value)) {
      return "At least ".concat(minLength, " character").concat(minLength !== 1 && 's', " required");
    }

    if (!max.test(value)) {
      return "Limit of ".concat(maxLength, " character").concat(maxLength !== 1 && 's', " allowed");
    }
  };
};

exports.getValidation = getValidation;